var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcPowerRange = function SvgAcPowerRange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#acPowerRange_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81 16.285 1.524 12 5.81 7.714M19.524 16.285 23.81 12l-4.286-4.286M12.667 12.428a.429.429 0 1 1 0-.857M12.667 12.428a.429.429 0 1 0 0-.857M16.953 12.428a.429.429 0 1 1 0-.857M16.953 12.428a.429.429 0 1 0 0-.857M8.382 12.428a.429.429 0 1 1 0-.857M8.382 12.428a.429.429 0 1 0 0-.857"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "acPowerRange_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 0h24v24h-24z"
  })))));
};
export default SvgAcPowerRange;